import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Router, ActivatedRoute } from '@angular/router';
import { Usuario } from '../base/vo/usuario';
import { isNullOrUndefined } from 'util';

//Service
import { IdentificarPrestadorExecutanteService } from './identificar-prestador-executante.service'
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

//Components
import { Beneficiario } from '../base/vo/beneficiario';
import { NovaGto } from '../base/vo/nova-gto';

@Component({
  selector: 'app-identificar-prestador-executante',
  templateUrl: './identificar-prestador-executante.component.html',
  styleUrls: ['./identificar-prestador-executante.component.css']
})
export class IdentificarPrestadorExecutanteComponent implements OnInit {

  @Input() beneficiario:     Beneficiario;
  @Input() fluxoAlternativo: boolean = true;
  @Output() gtoClinica:      EventEmitter<NovaGto> = new EventEmitter<NovaGto>();

  listaDePrestadorExecutante:  any;
  prestadorExecutante:         any;
  prestadorExecutanteFiltrado: any;

  //Boolean
  dropDownPrestExec: boolean = false;

  novaGto:       NovaGto;
  usuarioLogado: Usuario;

  constructor(public prestExecutanteService: IdentificarPrestadorExecutanteService,
              public autenticacaoService: AutenticacaoService ) { 

    this.carregarDadosPrestador();
  }

  ngOnInit() { 
    this.novaGto = new NovaGto();
    this.novaGto.beneficiario = this.beneficiario;
  }

  validaPrestExecutante(): boolean{
    if(isNullOrUndefined(this.novaGto.prestExecutante)){      
      return false;
    }
    else{
      return true;
    }
  }
 
  private carregarDadosPrestador(){
    
    this.prestExecutanteService.recuperaListaPrestadorExecutante().subscribe(
      data => {
        this.listaDePrestadorExecutante = data.data;      
      },
      error=>{console.log('Erro ao carregar lista prestadores executantes.')}
    );

    this.usuarioLogado = this.autenticacaoService.usuarioLogado;
        
  }

  autoCompletePrestador(event){
    this.prestadorExecutanteFiltrado = this.listaDePrestadorExecutante.filter(
      item => item.nome.toUpperCase().indexOf(event.query.toUpperCase()) !== -1);
  }

  public enviaGto(){
    this.novaGto.codigoStep = 2;
    this.gtoClinica.emit(this.novaGto);  
  }

  limpaPrestador(){
    this.novaGto.prestExecutante = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/identificar-prestador-executante/identificar-prestador-executante.component.ts